export const SET_CONVERSATION_LIST = 'SET_CONVERSATION_LIST';
export const SET_CONVERSATION_ID = 'SET_CONVERSATION_ID';
export const SET_ROUND_ID = 'SET_ROUND_ID';
export const SET_CHAT_LIST = 'SET_CHAT_LIST';
export const SET_CONVERSATION_TYPE = 'SET_CONVERSATION_TYPE';
export const SET_INPUT = 'SET_INPUT';
export const SET_INPUT_TYPE = 'SET_INPUT_TYPE';
export const SET_ANSWER_STATUS = 'SET_ANSWER_STATUS';
export const SET_SPEECHING = 'SET_SPEECHING';
export const SET_TOPIC_TYPE_LIST = 'SET_TOPIC_TYPE_LIST';
export const SET_TOPIC_TYPE = 'SET_TOPIC_TYPE';
export const SET_CONVERSATION_TYPE_LIST = 'SET_CONVERSATION_TYPE_LIST';
export const SET_RECOMMENDED_QUESTION = 'SET_RECOMMENDED_QUESTION';
export const SET_CONVERSATION_SHARE = 'SET_CONVERSATION_SHARE';
export const SET_SHARE_CONVERSATION = 'SET_SHARE_CONVERSATION';
export const SET_LOADING_CHAT_LIST = 'SET_LOADING_CHAT_LIST';
export const SET_ABORT_CONTROLLER = 'SET_ABORT_CONTROLLER';
export const SET_LOADING_CHAT = 'SET_LOADING_CHAT';
export const SET_COLLAPSED = 'SET_COLLAPSED';
export const SET_CONVERSATION_PAGE = 'SET_CONVERSATION_PAGE';
export const SET_CHAT_PAGE = 'SET_CHAT_PAGE';
export const SET_CACHE_CONVERSATION_ID = 'SET_CACHE_CONVERSATION_ID';
export const SET_CACHE_TOPIC_TYPE = 'SET_CACHE_TOPIC_TYPE';
export const SET_CONVERSATION_TOTAL = 'SET_CONVERSATION_TOTAL';
export const SET_CHAT_TOTAL = 'SET_CHAT_TOTAL';
export const SET_INIT_WELCOME_TOPIC = 'SET_INIT_WELCOME_TOPIC';
export const SET_INIT_WELCOME_COMPREHENSIVE = 'SET_INIT_WELCOME_COMPREHENSIVE';
export const SET_INTERACT = 'SET_INTERACT';
export const SET_IS_ANONYMOUS = 'SET_IS_ANONYMOUS';
